import { envConfig } from "@/config";

export const FormatExpiryTimeText = (currentTimestampMillis: number, inviteCodeExpiryTimestampMillis: number): string => {
	if (isNaN(inviteCodeExpiryTimestampMillis) || isNaN(currentTimestampMillis)) {
		return "--:--";
	}

	const difference = inviteCodeExpiryTimestampMillis - currentTimestampMillis;
	if (difference <= 0) {
		return "--:--";
	}

	const differenceSeconds = Math.floor(difference / 1000);
	const minutes = Math.floor(differenceSeconds / 60);
	const seconds = Math.floor(differenceSeconds % 60);
	return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};

export const InviteCodeTooltipText = (studentCount: number, codeInviteAllowed: boolean): string => {
	const MaxStudents = envConfig.MAX_STUDENTS;

	if (studentCount > MaxStudents) {
		return `Cannot add invite codes to classes with more than ${MaxStudents} students.`;
	}
	if (!codeInviteAllowed) {
		return "The invite code feature is not available for monitoring classes.";
	}
	return "";
};
